<template>
  <div class="ProductKeywordDeliveryMgmt">
    <div class="header-box">
      <div class="header-line"></div>
      <div class="header-line">
        <!-- <el-button type="primary" size="small" @click="getProductKeyword">查询</el-button> -->
        <el-button type="primary" size="small" @click="onConfigWordClick">配置投放词</el-button>
      </div>
    </div>
    <div class="title-text">商品信息：</div>
    <div class="product-box" ref="productInfo">
      <div class="product-info">
        <span class="product-info-text">产品名称：</span>
        <span>{{ productInfo.productName }}</span>
      </div>
      <div class="product-info">
        <span class="product-info-text">词根（_root_）：</span><span>{{ getDisplayWord(deliveryWordConfig.rootWords) }}</span>
        <el-button type="text" @click="onRootWordClick" style="margin-left: 20px; padding: 0px">新增</el-button>
      </div>
      <div class="product-info">
        <span class="product-info-text">核心大词（_core_）：</span><span>{{ getDisplayWord(deliveryWordConfig.coreWords) }}</span>
        <el-button type="text" @click="onCoreWordClick" style="margin-left: 20px; padding: 0px">新增</el-button>
      </div>
      <div class="product-info">
        <span class="product-info-text">一级长尾词（_first_）：</span><span>{{ getDisplayWord(deliveryWordConfig.firstLongTailWords) }}</span>
        <el-button type="text" @click="onFirstLongTailWordClick" style="margin-left: 20px; padding: 0px">新增</el-button>
      </div>
      <div class="product-info">
        <span class="product-info-text">二级长尾词（_second_）：</span><span>{{ getDisplayWord(deliveryWordConfig.secondLongTailWords) }}</span>
        <el-button type="text" @click="onSecondLongTailWordClick" style="margin-left: 20px; padding: 0px">新增</el-button>
      </div>
      <div class="product-info">
        <span class="product-info-text">三级长尾词（_third_）：</span><span>{{ getDisplayWord(deliveryWordConfig.thirdLongTailWords) }}</span>
        <el-button type="text" @click="onThirdLongTailWordClick" style="margin-left: 20px; padding: 0px">新增</el-button>
      </div>

      <div class="product-info">
        <span class="product-info-text">期望ACOS：</span><span>{{ deliveryWordConfig.expectedAcos }}</span>
      </div>
      <div class="product-info">
        <span class="product-info-text">手动广告期望CPS：</span><span>{{ deliveryWordConfig.expectedCps }}</span>
      </div>
      <div class="product-info">
        <span class="product-info-text">自动广告期望CPS：</span><span>{{ deliveryWordConfig.autoAdExpectedCps }}</span>
      </div>
      <div class="product-info">
        <span class="product-info-text">期望词根转化率：</span><span>{{ deliveryWordConfig.expectedRootWordRate }}</span>
      </div>
      <div class="product-info">
        <span class="product-info-text">期望核心大词转化率：</span><span>{{ deliveryWordConfig.expectedCoreWordRate }}</span>
      </div>
      <div class="product-info">
        <span class="product-info-text">期望一级长尾词转化率：</span><span>{{ deliveryWordConfig.expectedfirstLongTailWordRate }}</span>
      </div>
      <div class="product-info">
        <span class="product-info-text">主推核心词：</span><span>{{ getDisplayWord(deliveryWordConfig.recCoreWords) }}</span>
        <el-button type="text" @click="onRecCoreWordClick" style="margin-left: 20px; padding: 0px">新增</el-button>
      </div>
    </div>
    <div class="main-box" :height="screenHeight">
      <el-table :data="broadWordList" border size="small" style="width: 500px; display: inline-block; vertical-align: top">
        <!-- <el-table-column width="55">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checkStatus" @change="handleChange(scope.row)" :true-label="1" :false-label="0"></el-checkbox>
            </template>
          </el-table-column> -->
        <el-table-column label="序号" width="50px" align="right">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="keyword" label="广泛投放关键词" width="300px"> </el-table-column>
        <el-table-column prop="bid" label="出价" width="60px" align="right"> </el-table-column>
        <el-table-column prop="rate" label="预期转化率" width="80px" align="right">
          <template slot-scope="scope">
            {{ (scope.row.rate * 100).toFixed(2) + "%" }}
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="exactWordList" border size="small" style="width: 500px; display: inline-block; vertical-align: top">
        <!-- <el-table-column width="55">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checkStatus" @change="handleChange(scope.row)" :true-label="1" :false-label="0"></el-checkbox>
            </template>
          </el-table-column> -->
        <el-table-column label="序号" width="50px" align="right">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="keyword" label="精准投放关键词" width="300px"> </el-table-column>
        <el-table-column prop="bid" label="出价" width="60px" align="right"> </el-table-column>
        <el-table-column prop="rate" label="预期转化率" width="80px" align="right">
          <template slot-scope="scope">
            {{ (scope.row.rate * 100).toFixed(2) + "%" }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="配置投放词" :visible.sync="configWordDialogVisible" :close-on-click-modal="false" width="1000px">
      <div class="form-line">
        <span class="form-label">词根</span>
        <el-input class="form-input" placeholder="请输入" v-model="deliveryWordConfig.rootWords" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">核心大促</span>
        <el-input class="form-input" placeholder="请输入" v-model="deliveryWordConfig.coreWords" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">一级长尾词</span>
        <el-input class="form-input" placeholder="请输入" v-model="deliveryWordConfig.firstLongTailWords" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">二级长尾词</span>
        <el-input class="form-input" placeholder="请输入" v-model="deliveryWordConfig.secondLongTailWords" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">三级长尾词</span>
        <el-input class="form-input" placeholder="请输入" v-model="deliveryWordConfig.thirdLongTailWords" size="small" clearable> </el-input>
      </div>

      <div class="form-line">
        <span class="form-label">期望ACOS</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="deliveryWordConfig.expectedAcos" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">手动广告期望CPS</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="deliveryWordConfig.expectedCps" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">自动广告期望CPS</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="deliveryWordConfig.autoAdExpectedCps" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">期望词根转化率</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="deliveryWordConfig.expectedRootWordRate" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">期望核心大词转化率</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="deliveryWordConfig.expectedCoreWordRate" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">期望一级长尾词转化率</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="deliveryWordConfig.expectedfirstLongTailWordRate" size="small" clearable> </el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="configWordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="配置投放词" :visible.sync="deliveryConfigDialogVisible" :close-on-click-modal="false" width="1000px">
      <div class="form-line">
        <span class="form-label">关键词</span>
        <el-input class="form-input" placeholder="请输入" v-model="deliveryConfig.keyword" size="small" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label">期望转化率</span>
        <el-input class="form-input" type="number" placeholder="请输入" v-model="deliveryConfig.rate" size="small" clearable> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deliveryConfigDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDeliveryConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { colors, models, iPhoneModels, products, getPhoneCaseContantInfo } from "../../utils/constant.js";
export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 54 - 68,
      productType: this.$route.query.productType,
      configWordDialogVisible: false,
      deliveryConfigDialogVisible: false,
      productInfo: {},
      broadWordList: [],
      exactWordList: [],
      products: [],
      majorProduct: null,
      iPhoneModels: iPhoneModels,
      deliveryWordConfig: {
        rootWords: [],
        coreWords: [],
        firstLongTailWords: [],
        secondLongTailWords: [],
        thirdLongTailWords: [],
        expectedAcos: 0,
        expectedCps: 0,
        autoAdExpectedCps: 0,
        expectedRootWordRate: 0,
        expectedCoreWordRate: 0,
        expectedfirstLongTailWordRate: 0,
        recCoreWords: [],
      },
      deliveryConfig: {
        keyword: "",
        rate: "",
      },
      configWordType: "",
    };
  },
  mounted() {
    this.getParentProduct();
    this.getChildProducts();

    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 54 - 68;
    },
    getDisplayWord(wordsList) {
      let wordText = "";
      wordsList.forEach(word => (wordText += word.keyword + " (" + word.rate + "); "));
      return wordText;
    },
    onRootWordClick() {
      this.deliveryConfigDialogVisible = true;
      this.deliveryConfig = {
        keyword: "",
        rate: "",
      };
      this.configWordType = "root";
    },
    onCoreWordClick() {
      this.deliveryConfigDialogVisible = true;
      this.deliveryConfig = {
        keyword: "",
        rate: "",
      };
      this.configWordType = "core";
    },
    onFirstLongTailWordClick() {
      this.deliveryConfigDialogVisible = true;
      this.deliveryConfig = {
        keyword: "",
        rate: "",
      };
      this.configWordType = "firstLongTail";
    },
    onSecondLongTailWordClick() {
      this.deliveryConfigDialogVisible = true;
      this.deliveryConfig = {
        keyword: "",
        rate: "",
      };
      this.configWordType = "secondLongTail";
    },
    onThirdLongTailWordClick() {
      this.deliveryConfigDialogVisible = true;
      this.deliveryConfig = {
        keyword: "",
        rate: "",
      };
      this.configWordType = "thirdLongTail";
    },
    onRecCoreWordClick() {
      this.deliveryConfigDialogVisible = true;
      this.deliveryConfig = {
        keyword: "",
        rate: "",
      };
      this.configWordType = "recCoreWord";
    },
    handleDeliveryConfirmBtn() {
      let wordsList = [];
      this.configWordType == "root" && (wordsList = this.deliveryWordConfig.rootWords);
      this.configWordType == "core" && (wordsList = this.deliveryWordConfig.coreWords);
      this.configWordType == "firstLongTail" && (wordsList = this.deliveryWordConfig.firstLongTailWords);
      this.configWordType == "secondLongTail" && (wordsList = this.deliveryWordConfig.secondLongTailWords);
      this.configWordType == "thirdLongTail" && (wordsList = this.deliveryWordConfig.thirdLongTailWords);
      this.configWordType == "recCoreWord" && (wordsList = this.deliveryWordConfig.recCoreWords);

      !wordsList && (wordsList = []);

      let word = wordsList.find(word => word.keyword == this.deliveryConfig.keyword);
      if (word) {
        wordsList.forEach(word => {
          if (word.keyword == this.deliveryConfig.keyword) {
            word.expectedRate = deliveryConfig.rate;
          }
        });
      } else {
        wordsList.push(this.deliveryConfig);
      }

      let params = {
        productType: this.productType,
        ...this.deliveryWordConfig,
      };
      params.rootWords = JSON.stringify(params.rootWords);
      params.coreWords = JSON.stringify(params.coreWords);
      params.firstLongTailWords = JSON.stringify(params.firstLongTailWords);
      params.secondLongTailWords = JSON.stringify(params.secondLongTailWords);
      params.thirdLongTailWords = JSON.stringify(params.thirdLongTailWords);
      params.recCoreWords = JSON.stringify(params.recCoreWords);
      requestModules
        .updateDeliveryWordConfig(params)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.deliveryConfigDialogVisible = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getParentProduct() {
      requestModules.fetchParentProducts({ productType: this.productType }).then(res => {
        this.productInfo = res.ldata[0];

        this.deliveryWordConfig.expectedAcos = this.productInfo.expectedAcos;
        this.deliveryWordConfig.expectedCps = this.productInfo.expectedCps;
        this.deliveryWordConfig.autoAdExpectedCps = this.productInfo.autoAdExpectedCps;
        this.deliveryWordConfig.expectedRootWordRate = this.productInfo.expectedRootWordRate;
        this.deliveryWordConfig.expectedCoreWordRate = this.productInfo.expectedCoreWordRate;
        this.deliveryWordConfig.expectedfirstLongTailWordRate = this.productInfo.expectedfirstLongTailWordRate;

        this.deliveryWordConfig.rootWords = [];
        this.deliveryWordConfig.coreWords = [];
        this.deliveryWordConfig.firstLongTailWords = [];
        this.deliveryWordConfig.secondLongTailWords = [];
        this.deliveryWordConfig.thirdLongTailWords = [];
        this.deliveryWordConfig.recCoreWords = [];

        (this.productInfo.rootWords && this.productInfo.rootWords.length) > 0 && (this.deliveryWordConfig.rootWords = JSON.parse(this.productInfo.rootWords));
        (this.productInfo.coreWords && this.productInfo.coreWords.length) > 0 && (this.deliveryWordConfig.coreWords = JSON.parse(this.productInfo.coreWords));
        (this.productInfo.firstLongTailWords && this.productInfo.firstLongTailWords.length) > 0 && (this.deliveryWordConfig.firstLongTailWords = JSON.parse(this.productInfo.firstLongTailWords));
        (this.productInfo.secondLongTailWords && this.productInfo.secondLongTailWords.length) > 0 && (this.deliveryWordConfig.secondLongTailWords = JSON.parse(this.productInfo.secondLongTailWords));
        (this.productInfo.thirdLongTailWords && this.productInfo.thirdLongTailWords.length) > 0 && (this.deliveryWordConfig.thirdLongTailWords = JSON.parse(this.productInfo.thirdLongTailWords));
        (this.productInfo.recCoreWords && this.productInfo.recCoreWords.length) > 0 && (this.deliveryWordConfig.recCoreWords = JSON.parse(this.productInfo.recCoreWords));
      });
    },
    getChildProducts() {
      requestModules.fetchProducts({ productType: this.productType, beginIndex: 0, pageSize: 1000 }).then(res => {
        this.products = res.ldata;

        this.majorProduct = this.products.find(pd => ((pd.majorLevel == pd.isHasModel) == 1 ? 2 : 1));
      });
    },
    onConfigWordClick() {
      this.configWordDialogVisible = true;
    },
    handleConfirmBtn() {
      this.initBroadDeliveryWords();
      this.initExactDeliveryWords();

      requestModules
        .updateDeliveryWordConfig({
          productType: this.productType,
          expectedAcos: this.deliveryWordConfig.expectedAcos,
          expectedCps: this.deliveryWordConfig.expectedCps,
          autoAdExpectedCps: this.deliveryWordConfig.autoAdExpectedCps,
          expectedRootWordRate: this.deliveryWordConfig.expectedRootWordRate,
          expectedCoreWordRate: this.deliveryWordConfig.expectedCoreWordRate,
          expectedfirstLongTailWordRate: this.deliveryWordConfig.expectedfirstLongTailWordRate,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.configWordDialogVisible = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    initBroadDeliveryWords() {
      let rootList = [];
      let coreList = [];
      let firstList = [];
      let rootFirstList = [];
      let rootWords = this.deliveryWordConfig.rootWords;
      let coreWords = this.deliveryWordConfig.coreWords;
      let firstLongTailWords = this.deliveryWordConfig.firstLongTailWords;
      // let secondLongTailWords = this.deliveryWordConfig.secondLongTailWords.split(";");
      // let thirdLongTailWords = this.deliveryWordConfig.thirdLongTailWords.split(";");

      let modelInfo = this.getModelInfo(this.majorProduct.model);
      !modelInfo && (modelInfo = { model: "" });

      let modelReg = new RegExp("_model_", "igm");
      let colorReg = new RegExp("_color_", "igm");
      let blankReg = new RegExp(" ", "igm");

      // rootWords = ["iphone case", "phone case", "iphone _model_ case", "iphone _model_ phone case", "phone _model_ case", "_model_ case"];

      rootWords.forEach(root => {
        let keyword = root.keyword.replace(modelReg, modelInfo.model.toLowerCase());
        let rate = parseFloat(root.rate) - 0.02;
        let bid = (rate * this.deliveryWordConfig.expectedCps).toFixed(2);
        root.keyword != "" && rootList.push({ keyword, bid: parseFloat(bid), rate: rate });
      });

      rootWords.forEach(root => {
        coreWords.forEach(core => {
          let keyword = (root.keyword + " " + core.keyword).replace(modelReg, modelInfo.model.toLowerCase());
          let rate = parseFloat(root.rate) + parseFloat(core.rate) - 0.02;
          let bid = (rate * this.deliveryWordConfig.expectedCps).toFixed(2);
          root.keyword != "" && core.keyword != "" && coreList.push({ keyword, bid: parseFloat(bid), rate: rate });
        });
      });
      rootWords.forEach(root => {
        firstLongTailWords.forEach(word => {
          let keyword = (root.keyword + " " + word.keyword).replace(modelReg, modelInfo.model.toLowerCase()).replace(colorReg, this.majorProduct.productColor.toLowerCase());
          let rate = parseFloat(root.rate) + parseFloat(word.rate) - 0.02;
          let bid = (rate * this.deliveryWordConfig.expectedCps).toFixed(2);
          root.keyword != "" && word.keyword != "" && rootFirstList.push({ keyword, bid: parseFloat(bid), rate: rate });
        });
      });
      coreList.forEach(core => {
        firstLongTailWords.forEach(word => {
          let keyword = (core.keyword + " " + word.keyword).replace(colorReg, this.majorProduct.productColor.toLowerCase());
          let rate = parseFloat(core.rate) + parseFloat(word.rate) - 0.02;
          let bid = (rate * this.deliveryWordConfig.expectedCps).toFixed(2);
          word.keyword != "" && firstList.push({ keyword, bid: parseFloat(bid), rate: rate });
        });
      });
      this.broadWordList = [...coreList, ...rootFirstList, ...firstList];
    },
    initExactDeliveryWords() {
      let rootList = [];
      let coreList = [];
      let firstList = [];
      let rootFirstList = [];
      let rootWords = [...this.deliveryWordConfig.rootWords];
      let coreWords = this.deliveryWordConfig.coreWords;
      let firstLongTailWords = this.deliveryWordConfig.firstLongTailWords;
      // let secondLongTailWords = this.deliveryWordConfig.secondLongTailWords.split(";");
      // let thirdLongTailWords = this.deliveryWordConfig.thirdLongTailWords.split(";");

      let modelInfo = this.getModelInfo(this.majorProduct.model);
      !modelInfo && (modelInfo = { model: "" });

      let modelReg = new RegExp("_model_", "igm");
      let colorReg = new RegExp("_color_", "igm");
      let blankReg = new RegExp(" ", "igm");

      // rootWords = ["iphone case", "phone case", "iphone _model_ case", "iphone _model_ phone case", "phone _model_ case", "_model_ case", "case iphone _model_", "case phone _model_", "case _model_"];
      // this.deliveryWordConfig.rootWords.forEach(word => {
      //   if (word.keyword != "phone case") {
      //     rootWords.push({
      //       keyword: "case " + word.keyword.replace(" case", ""),
      //       bid: word.bid,
      //       rate: word.rate,
      //     });
      //   }
      // });

      rootWords.forEach(root => {
        let keyword = root.keyword.replace(modelReg, modelInfo.model.toLowerCase());
        let rate = parseFloat(root.rate);
        let bid = (rate * this.deliveryWordConfig.expectedCps).toFixed(2);
        root.keyword != "" && rootList.push({ keyword, bid: parseFloat(bid), rate: rate });
      });

      rootWords.forEach(root => {
        coreWords.forEach(core => {
          let keyword = (root.keyword + " " + core.keyword).replace(modelReg, modelInfo.model.toLowerCase());
          let rate = parseFloat(root.rate) + parseFloat(core.rate);
          let bid = (rate * this.deliveryWordConfig.expectedCps).toFixed(2);
          root.keyword != "" && core.keyword != "" && coreList.push({ keyword, bid: parseFloat(bid), rate: rate });
        });
      });

      rootWords.forEach(root => {
        firstLongTailWords.forEach(word => {
          let keyword = (root.keyword + " " + word.keyword).replace(modelReg, modelInfo.model.toLowerCase()).replace(colorReg, this.majorProduct.productColor.toLowerCase());
          let rate = parseFloat(root.rate) + parseFloat(word.rate);
          let bid = (rate * this.deliveryWordConfig.expectedCps).toFixed(2);
          root.keyword != "" && word.keyword != "" && rootFirstList.push({ keyword, bid: parseFloat(bid), rate: rate });
        });
      });

      // coreList.forEach(core => {
      //   firstLongTailWords.forEach(word => {
      //     let keyword1 = (core.keyword + " " + word).replace(colorReg, this.majorProduct.productColor.toLowerCase());
      //     let keyword2 = (word + " " + core.keyword).replace(colorReg, this.majorProduct.productColor.toLowerCase());
      //     let bid = ((this.deliveryWordConfig.expectedfirstLongTailWordRate + this.deliveryWordConfig.expectedCoreWordRate + this.deliveryWordConfig.expectedRootWordRate) * this.deliveryWordConfig.expectedCps).toFixed(2);
      //     word != "" && firstList.push({ keyword: keyword1, bid: parseFloat(bid) });
      //     word != "" && firstList.push({ keyword: keyword2, bid: parseFloat(bid) });
      //   });
      // });

      coreList.forEach(core => {
        firstLongTailWords.forEach(word => {
          let keyword1 = (core.keyword + " " + word.keyword).replace(colorReg, this.majorProduct.productColor.toLowerCase());
          // let keyword2 = (word.keyword + " " + core.keyword).replace(colorReg, this.majorProduct.productColor.toLowerCase());
          let rate = parseFloat(core.rate) + parseFloat(word.rate);
          let bid = (rate * this.deliveryWordConfig.expectedCps).toFixed(2);
          word.keyword != "" && firstList.push({ keyword: keyword1, bid: parseFloat(bid), rate: rate });
          // word.keyword != "" && firstList.push({ keyword: keyword2, bid: parseFloat(bid), rate: rate });
        });
      });

      this.exactWordList = [...coreList, ...rootFirstList, ...firstList];
    },
    getModelInfo(model) {
      let blankReg = new RegExp(" ", "igm");
      let info = this.iPhoneModels.find(md => md.model.replace(blankReg, "") == model);
      return info;
    },
  },
  computed: {},
};
</script>

<style lang="scss">
.ProductKeywordDeliveryMgmt {
  .title-text {
    font-size: 18px;
    font-weight: bold;
    margin: 10px 0 5px 0;
  }

  .one-word-normal-table {
    width: 400px;
    display: inline-block;
    vertical-align: top;
  }

  .one-word-analyze-table {
    width: 1200px;
    display: inline-block;
    vertical-align: top;
  }

  .product-box {
    padding: 10px;
    margin: 10px 0px;
    background-color: white;

    .red {
      color: red;
    }

    .product-info {
      .product-info-text {
        display: inline-block;
        width: 220px;
        text-align: right;
        font-weight: bold;
      }
    }
  }
  .word-analyze-box {
    background-color: white;
    padding: 10px;
  }
  .no-padding {
    padding: 0px !important;
    .cell {
      padding: 0px !important;
    }
  }
  .form-line {
    .form-label {
      margin: 5px 10px 5px 0px;
      width: 80px;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 800px;
      margin: 5px 0px;
      vertical-align: top;
    }
    .form-group {
      width: 750px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
      .el-radio {
        width: 70px;
      }
    }
  }

  .redBg {
    background-color: red;
    color: white;
  }
  .yellowBg {
    background-color: yellow;
  }
  .greenBg {
    background-color: green;
    color: white;
  }
  .redText {
    color: red;
  }
  .greenText {
    color: green;
  }
}
</style>
